import styled, { css } from 'styled-components';

// Flex Column
const StyledCol = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.alignItems && css`align-items: ${(props) => props.alignItems};`};
  ${(props) => props.justifyContent && css`justify-content: ${(props) => props.justifyContent};`};
  ${(props) => props.flex && css`flex: ${(props) => props.flex};`};
  ${(props) => props.nowrap && css`white-space: nowrap;`};
  ${(props) => props.wrap && css`flex-wrap: wrap;`};
  ${(props) => props.padding && css`padding: ${(props) => props.padding};`};
  ${(props) => props.margin && css`margin: ${(props) => props.margin};`};
`;

// Flex Row
const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  ${(props) => props.flex && css`flex: ${(props) => props.flex};`};
  ${(props) => props.nowrap && css`white-space: nowrap;`};
  ${(props) => props.wrap && css`flex-wrap: wrap;`};
  ${(props) => props.padding && css`padding: ${(props) => props.padding};`};
  ${(props) => props.margin && css`margin: ${(props) => props.margin};`};
`;

export const Flex = {
  Col: StyledCol,
  Row: StyledRow
};